import { differenceInSeconds } from 'date-fns';

export const secondsToHms = (s = 0) => {
    const seconds = parseInt(s);
    if (isNaN(seconds)) return {};
    var hr = Math.floor(seconds / 3600);
    var mn = Math.floor(seconds % 3600 / 60);
    var sec = Math.floor(seconds % 3600 % 60);
    return { hr, mn, sec };
};

export const pad = (n) => {
    const num = parseInt(n);
    if (isNaN(num)) return '00';
    return num < 10 ? '0' + num : num;
};

export const isTimePassed = (timeInStr) => {
    const diff = differenceInSeconds(
        new Date(timeInStr),
        new Date()
    );
    return diff <= 0;
};